import { http } from './http';
import {
  roadCodeOverviewOf,
  type AnswerReply,
  type Letter,
  type LessonCatalog,
  type LessonView,
  type RoadCodeOverview,
  type RoadCodeSeries,
  type SeriesStart,
} from '../lib/roadCode';

// Révision du code de la route, ouverte par l'auto-école (achat dans la Boutique Permio).

const BASE = '/v1/candidate-portal/me/road-code';

export const ROAD_CODE_KEY = ['candidate', 'road-code'] as const;

/** Accueil de l'onglet Code ; `null` si la réponse est inattendue (onglet caché). */
export async function fetchRoadCodeOverview(): Promise<RoadCodeOverview | null> {
  const { data } = await http.get<unknown>(BASE);
  return roadCodeOverviewOf(data);
}

export async function startRoadCodeSeries(body: SeriesStart): Promise<RoadCodeSeries> {
  const { data } = await http.post<RoadCodeSeries>(`${BASE}/series`, body);
  return data;
}

export async function fetchRoadCodeSeries(id: string): Promise<RoadCodeSeries> {
  const { data } = await http.get<RoadCodeSeries>(`${BASE}/series/${id}`);
  return data;
}

export async function answerRoadCodeQuestion(
  seriesId: string,
  body: { position: number; selected: Letter[]; elapsedMs: number },
): Promise<AnswerReply> {
  const { data } = await http.post<AnswerReply>(`${BASE}/series/${seriesId}/answers`, body);
  return data;
}

export async function abandonRoadCodeSeries(seriesId: string): Promise<void> {
  await http.post(`${BASE}/series/${seriesId}/abandon`);
}

export async function fetchRoadCodeLessons(): Promise<LessonCatalog> {
  const { data } = await http.get<LessonCatalog>(`${BASE}/lessons`);
  return data;
}

export async function fetchRoadCodeLesson(id: string): Promise<LessonView> {
  const { data } = await http.get<LessonView>(`${BASE}/lessons/${encodeURIComponent(id)}`);
  return data;
}

export async function markRoadCodeLessonRead(id: string, sections: number): Promise<{ id: string; read: number; sections: number }> {
  const { data } = await http.post<{ id: string; read: number; sections: number }>(
    `${BASE}/lessons/${encodeURIComponent(id)}/read`,
    { sections },
  );
  return data;
}

/** Illustration d'une question ou d'une fiche (route protégée : le jeton part en en-tête). */
export async function fetchRoadCodeMedia(file: string): Promise<Blob> {
  const { data } = await http.get<Blob>(`${BASE}/media/${encodeURIComponent(file)}`, { responseType: 'blob' });
  return data;
}
